export const ERROR_MESSAGES = {
    heading: "Something went wrong",
    description: "Our best minds are on this, please try again",
    ctaText: "Retry",
} as const;
